import type { PostMediaUI, PostPersistenceMediaUI } from '../../ui/posts/types';

export const fromPostPersistenceMediaUI = (
    media: PostPersistenceMediaUI,
): PostMediaUI | undefined => {
    if (media.type === 'video') {
        return {
            type: 'video',
            id: media.id,
            media: [
                {
                    width: media.width,
                    height: media.height,
                    url: media.url,
                    firstFrameUrl: media.firstFrameUrl,
                },
            ],
        };
    }

    if (media.type === 'image') {
        return {
            type: 'image',
            id: media.id,
            media: [
                {
                    width: media.width,
                    height: media.height,
                    url: media.url,
                },
            ],
        };
    }

    return undefined;
};
